import { Injectable } from '@angular/core';
import { BaseAgency, EntitlementsHelperService, LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure } from '@ptl/account-management';
import { ContentStorageService } from '@ptl/global-components';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { BrandingConfigurationService, brandWV } from '@ptl/brand';
import { CommonUtilityService } from '../../shared/utility-services/common-utility.service';
import { ZipCountyStateStructure } from '../shared/interfaces/zipCountyStateStructure.interface';

@Injectable({
  providedIn: 'root'
})
export class ProducerAgencyHelperService {

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private brandService: BrandingConfigurationService
  ) { }

  getAgencyRegionCode(agency: BaseAgency): number {
    const loginInfo: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);
    let curRegion = agency.region;
    return loginInfo.userInfo.regions.filter((region) => region.region == curRegion)[0].code;
  }

  padAgencyId(agencyId: string) {
    if (typeof agencyId !== 'string' && typeof agencyId !== 'number') {
      throw new TypeError('Agency ID is not a number or string');
    }

    if (agencyId.length < 10) {
      return Array((10 - agencyId.length) + 1).join('0') + agencyId;
    }
    else {
      return agencyId;
    }
  } 

  getDeepLink(): string {
    const curBrand = this.brandService.getCurrentBrand();
    const host = window.location.host;
    let prefix = 'www';
    const domain = curBrand.domain;

    // Special logic for lower environments
    if (host.indexOf("tenv") > -1 || host.indexOf("denv") > -1){
      // need to pull appropriate environment # from the host. Ex: "producerdenv3.highmark.com" would yield '3'
      prefix = 'tenv' + host.charAt(host.indexOf('.')-1);
    }

    return prefix + '.' + domain;
  }
  
  getDeepLinkEmployer(): string {
    const curBrand = this.brandService.getCurrentBrand();
    const host = window.location.host;
    let prefix = 'www';
    
    let domain = curBrand.domain;
    
    // Special logic for lower environments
    if (host.indexOf("tenv") > -1 || host.indexOf("denv") > -1){
      // need to pull appropriate environment # from the host. Ex: "producerdenv3.highmark.com" would yield '3'
      prefix = 'tenv' + host.charAt(host.indexOf('.')-1);
    }

    if (curBrand === brandWV) {
      domain = 'mybenefitshome.com';
    }

    return 'https://' + prefix + '.' + domain;
  }

  getDeepLinkNewEmployer(): string {
    const curBrand = this.brandService.getCurrentBrand();
    const host = window.location.host;
    let prefix = 'www';
    let domain;

    if (host.includes("highmark")) {
      domain = "highmark.com"
    } else {
      domain = curBrand.domain;
    }
    
    // Special logic for lower environments
    if (host.indexOf("tenv") > -1 || host.indexOf("denv") > -1){
      // need to pull appropriate environment # from the host. Ex: "producerdenv3.highmark.com" would yield '3'
      prefix = 'tenv' + host.charAt(host.indexOf('.')-1);
    }

    return prefix + '.' + domain;
  }

  hasEntitlement(agency: BaseAgency, entitlement: string) {
    const entitlements = agency.entitlements;
    return !!(entitlements.filter((eTitle) => eTitle.hasEntitlement && eTitle.descriptionKey === entitlement).length);
  }

  isRegionMismatch(agency: BaseAgency, zipCountyState: ZipCountyStateStructure) {
    if (zipCountyState?.county?.state === agency?.region) {
      return false;
    } 
    else {
      return true;
    }
  }
}
